import { createContext, useContext } from 'react';

const ServerContext = createContext({
        "DatabaseServer": "192.168.50.183",
        "DatabasePort": "8000"
    });

export const useServerProps = () => {
    return useContext(ServerContext);
}